module.exports = __webpack_public_path__ + "img/car3.97380478.png";